/**
 * packageInstance.js (WP-6)
 *
 * C2 instance-name helpers. A bound package node carries an author-assigned
 * instanceName, unique per host survey, validated like a variable name.
 */

// C2 charset rule — same as variable names.
const INSTANCE_RE = /^[A-Za-z][A-Za-z0-9_]*$/;

export function isValidInstanceName(name) {
  return typeof name === 'string' && INSTANCE_RE.test(name);
}

/** Slugify a package title into a valid instance-name stem (alpha-first). */
export function slugifyInstance(title) {
  let s = String(title || 'package')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
  if (!s || !/^[a-z]/.test(s)) s = `pkg_${s}`.replace(/_+$/g, '');
  return s || 'pkg';
}

/**
 * Collect existing package-instance names from the host graph.
 */
export function existingInstanceNames(nodes = []) {
  return new Set(
    nodes
      .filter((n) => n.type === 'package' && n.data?.instanceName)
      .map((n) => String(n.data.instanceName))
  );
}

/**
 * Suggest a default instance name `${slug}_${n}` unique among the host's package
 * instance names. If the bare slug is free, it is used as-is.
 */
export function suggestInstanceName(title, nodes = []) {
  const taken = existingInstanceNames(nodes);
  const stem = slugifyInstance(title);
  if (!taken.has(stem)) return stem;
  let n = 2;
  while (taken.has(`${stem}_${n}`)) n += 1;
  return `${stem}_${n}`;
}
